import { convertRemToPixels } from "../../../shared/js/helpers/rem-to-px";

window.addEventListener('load', () => {
    const validPage = document.querySelector('.page-homedesign, .page-displayhome, .page-houselandpackage');

    if (validPage) {
        // Function to toggle data-active state on buttons
        function toggleActiveButton(targetButton) {
            const buttons = validPage.querySelectorAll('[data-sticky-detail-button]');
            buttons.forEach(button => {
                button.dataset.active = (button === targetButton).toString();
            });
        }

        // Function to get the element at the specified height from the top
        function getElementAtHeight(height) {
            const panels = validPage.querySelectorAll('#headerPanel, #homeInclusionsPanel, #mediaPanel, #formPanel');
            let element = null;

            for (let i = 0; i < panels.length; i++) {
                const panel = panels[i];
                const panelTop = panel.getBoundingClientRect().top + window.scrollY; // Include scroll position

                if (panelTop <= height) {
                    element = panel;
                } else {
                    break; // Stop checking once we've passed the specified height
                }
            }

            return element;
        }

        // Function to update active state based on scroll position
        function updateActiveState() {
            const viewportTop = window.scrollY;
            const height = convertRemToPixels(8);
            const element = getElementAtHeight(viewportTop + height);

            if (element) {
                const targetId = element.getAttribute('id');
                const correspondingButton = validPage.querySelector(`[data-destination="#${targetId}"]`);
                toggleActiveButton(correspondingButton);
            }
        }

        // Throttle the scroll event to limit the update frequency
        const throttledUpdateActiveState = _throttle(updateActiveState, 100);

        // Update active state when the page loads
        updateActiveState();

        // Update active state on scroll using the throttled function
        window.addEventListener('scroll', throttledUpdateActiveState);
    }
});
